import { Action } from "redux";
import {
  AUTHENTICATE_USER,
  SET_ALREADY_SUBMITTED_STATE,
  SET_VALID_LOGIN_STATUS,
  SET_COMMUNICATION_ERROR_STATUS
} from "./constants";


export enum LoginErrorCodes {
    None = "None",
    AccountIsLockedDueToTooManyInvalidLogins = "AccountIsLockedDueToTooManyInvalidLogins",
    InvalidUserNameOrPassword = "InvalidUserNameOrPassword",
    AccountLockedDueToInactivityOrHasPassedDeactivatedDate = "AccountLockedDueToInactivityOrHasPassedDeactivatedDate",
    AccountHasBeenLockedByAnAdministrator = "AccountHasBeenLockedByAnAdministrator",
    AccountNotActiveYet = "AccountNotActiveYet",
    AccountDeactivated = "AccountDeactivated",
    AccountHasTempPassword = "AccountHasTempPassword"
}

/**
 * This Store manages any utilities used for the developper. 
 */
export interface LoginState {
    isAuthenticated: boolean,
    isAlreadySubmitted: boolean,
    isValidLogin: boolean,
    loginErrorCode: LoginErrorCodes,
    isHavingIssuesWithConnectionToMyle: boolean
}

export interface AuthenticateUserAction extends Action {
    type: AUTHENTICATE_USER;
    payload: {
        isAuthenticated: boolean;
    };
}

export interface ChangeLoginInformationAlreadySubmissionStateAction extends Action {
    type: SET_ALREADY_SUBMITTED_STATE;
    payload: {
        isAlreadySubmitted: boolean;
    };
}

export interface ToggleInvalidLoginAction extends Action {
    type: SET_VALID_LOGIN_STATUS,
    payload: {
        isValid: boolean;
    };
}

export interface ToggleMyleCommunicationIssuesStateAction extends Action {
    type: SET_COMMUNICATION_ERROR_STATUS,
    payload: {
        isHavingIssuesWithConnectionToMyle: boolean;
    };
}
export type LoginActions =
  | ToggleMyleCommunicationIssuesStateAction
  | ToggleInvalidLoginAction
  | ChangeLoginInformationAlreadySubmissionStateAction
  | AuthenticateUserAction;


// WEBPACK FOOTER //
// ./src/store/Login/type.ts